// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__tt9Vi","skeleton-animation":"styles_skeleton-animation__tj1wW"};